import React from "react";
import AutorenewIcon from "@mui/icons-material/Autorenew";

interface RecurrenceUpdatePromptProps {
  isOriginal: boolean;
  onConfirm: () => void;
  onDismiss: () => void;
  isLoading?: boolean;
}

export const RecurrenceUpdatePrompt: React.FC<RecurrenceUpdatePromptProps> = ({
  isOriginal,
  onConfirm,
  onDismiss,
  isLoading = false,
}) => {
  const message = isOriginal
    ? "自動作成設定のもとになったタスクが編集されました。同様の内容で自動作成設定も更新しますか？"
    : "自動作成によって作られたタスクが編集されました。同様の内容で自動作成設定も更新しますか？";

  return (
    <div className="fixed bottom-6 left-4 right-4 sm:left-auto sm:right-6 sm:w-auto sm:max-w-sm z-50 bg-white border border-gray-200 rounded-lg shadow-xl p-4 animate-slide-in-right">
      <div className="flex items-start gap-3">
        <AutorenewIcon className="text-blue-500 mt-0.5 flex-shrink-0" fontSize="small" />
        <div className="flex-1 min-w-0">
          <p className="text-sm text-gray-800 leading-snug">{message}</p>
          <div className="flex gap-2 mt-3">
            <button
              onClick={onConfirm}
              disabled={isLoading}
              className="px-3 py-1.5 bg-blue-500 text-white text-xs rounded hover:bg-blue-600 disabled:opacity-50 transition-colors"
            >
              {isLoading ? "更新中..." : "更新する"}
            </button>
            <button
              onClick={onDismiss}
              disabled={isLoading}
              className="px-3 py-1.5 bg-gray-100 text-gray-700 text-xs rounded hover:bg-gray-200 disabled:opacity-50 transition-colors"
            >
              しない
            </button>
          </div>
        </div>
        <button
          onClick={onDismiss}
          disabled={isLoading}
          className="flex-shrink-0 text-gray-400 hover:text-gray-600 transition-colors"
        >
          <span className="text-lg leading-none">&times;</span>
        </button>
      </div>
    </div>
  );
};
